export const getPetBreedIds = pet => {
  const breedIds = pet?.breed_ids?.length
    ? pet.breed_ids
    : pet?.breeds?.map(breed => breed.id).filter(Boolean);

  return breedIds?.length ? breedIds : null;
};

export const getPetAllergyIds = pet => {
  const allergyIds = pet?.allergy_ids?.length
    ? pet.allergy_ids
    : pet?.allergies?.map(allergy => allergy.id).filter(Boolean);

  return allergyIds?.length ? allergyIds : null;
};

export const buildUpdatedPetData = (existingPet, values) => {
  if (!existingPet) {
    return values;
  }

  return {
    id: existingPet.id ?? null,
    name: existingPet.name ?? null,
    is_neutered: existingPet.is_neutered ?? null,
    weight: existingPet.weight ?? null,
    ideal_weight: existingPet.ideal_weight ?? null,
    gender: existingPet.gender ?? null,
    activity_level: existingPet.activity_level ?? null,
    breed_ids: getPetBreedIds(existingPet),
    allergy_ids: getPetAllergyIds(existingPet),
    ...values,
  };
};
